export default class EventGameTiebreaker {
  public statTotal: number | null = 0;
}
